import { withTranslation } from "react-i18next";

function Main({ MainComponent, data }) {
  return <MainComponent {...data} />;
}

export default withTranslation()(Main);
